var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiscover = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.045,
    height: 21.461,
    viewBox: "0 0 30.045 21.461",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e1e7ea;}.b{fill:#ff6d00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.045,27.6a2.87,2.87,0,0,1-2.861,2.861H5.861A2.87,2.87,0,0,1,3,27.6V11.861A2.87,2.87,0,0,1,5.861,9H30.184a2.87,2.87,0,0,1,2.861,2.861Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.745,31.015a2.87,2.87,0,0,1-2.861,2.861H16s16.882-2.718,20.745-10.73ZM20.292,23.146A2.146,2.146,0,1,0,22.438,21,2.108,2.108,0,0,0,20.292,23.146Z",
    transform: "translate(-3.7 -3.416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72,20.972h.787v4.292H9.72Zm4.292,2.146a2.108,2.108,0,0,0,2.146,2.146,2.525,2.525,0,0,0,1-.215v-.93a1.3,1.3,0,0,1-1,.429A1.334,1.334,0,0,1,14.8,23.118a1.375,1.375,0,0,1,1.359-1.431,1.546,1.546,0,0,1,1,.429v-.93a2.652,2.652,0,0,0-1-.286A2.263,2.263,0,0,0,14.012,23.118Zm9.586.644-1.145-2.79h-.858l1.788,4.292h.429L25.6,20.972h-.858Zm2.361,1.5h2.289v-.715h-1.5V23.4h1.431v-.715H26.745v-1h1.5v-.715H25.958v4.292Zm5.437-3c0-.787-.5-1.288-1.431-1.288H28.748v4.292h.787V23.547h.072l1.145,1.717h1l-1.288-1.788A1.171,1.171,0,0,0,31.4,22.259Zm-1.645.715h-.215V21.687h.215c.5,0,.787.215.787.644C30.537,22.688,30.322,22.975,29.75,22.975Zm-22.534-2H6v4.292H7.145a2.127,2.127,0,0,0,2.218-2.146A1.991,1.991,0,0,0,7.216,20.972ZM7,24.548H6.787V21.687h.286A1.435,1.435,0,1,1,7,24.548Zm5.651-1.931c-.5-.215-.644-.286-.644-.5,0-.286.286-.429.572-.429a.757.757,0,0,1,.644.358l.429-.572a1.569,1.569,0,0,0-1.216-.5,1.224,1.224,0,0,0-1.288,1.216c0,.572.286.858,1,1.145.429.143.787.286.787.644a.584.584,0,0,1-.644.572.93.93,0,0,1-.858-.572l-.5.5a1.51,1.51,0,0,0,1.431.787A1.335,1.335,0,0,0,13.8,23.9C13.8,23.261,13.511,22.975,12.653,22.617Z",
    transform: "translate(-0.854 -3.387)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiscover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/discover.cf27ff0c86de7515fa36f5d25970af74.svg";